import { render, staticRenderFns } from "./x-select.vue?vue&type=template&id=2638cadf&scoped=true&"
import script from "./x-select.vue?vue&type=script&lang=js&"
export * from "./x-select.vue?vue&type=script&lang=js&"
import style0 from "./x-select.vue?vue&type=style&index=0&id=2638cadf&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638cadf",
  null
  
)

export default component.exports